<template>
  <section id="content">
    <div class="content-wrap">
      <Why />
      <Surgery />
      <SurgeryResult />
      <Star />
      <!-- <Review /> -->
      <!-- <CounselForm /> -->
      <MobileStickyForm />
    </div>
  </section>
</template>

<script>
import Why from "./landingContents/LandingWhy.vue";
import Surgery from "./contents/Surgery.vue";
import SurgeryResult from "./landingContents/LandingSurgeryResult.vue";
import Star from "./contents/YoutubeStar.vue";
// import Review from "./contents/ReviewList.vue";
// import CounselForm from "./landingContents/CounselForm.vue";
import MobileStickyForm from "./MobileStickyForm.vue";
// import { isMobile } from "mobile-device-detect";

export default {
  name: "Contents",

  components: {
    Why,
    Surgery,
    SurgeryResult,
    Star,
    // CounselForm,
    // Review,
    MobileStickyForm
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
